/*
    Flickity
*/
import Flickity from 'flickity';


export default class Slider {
    constructor(sliderPartClass, options = {}) {
        //start params
        this.slider = null;
        this.defaultOptions = {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: '>1'
        };

        //merge options
        this.options = {...this.defaultOptions, ...options};

        //controls
        this.sliderClass = `.js-${sliderPartClass}-slider`;
        this.sliderNextClass = `.js-${sliderPartClass}-next`;
        this.sliderPrevClass = `.js-${sliderPartClass}-prev`;
        this.dotsClass = `.js-${sliderPartClass}-dots`;

        //init
        this.init();
    }

    init() {
        const el = document.querySelector(this.sliderClass);
        if(!el) return;

        this.slider = new Flickity( el, this.options);
        this.initprevNext();
        this.initDots();
    }

    //add event listeners
    initprevNext() {
        //prev
        const prev = document.querySelectorAll(this.sliderPrevClass);
        
        if(prev) {
            for(let el of prev) {
                el.addEventListener('click', e => {
                    this.slider.previous();
                });
            }
        }

        //next
        const next = document.querySelectorAll(this.sliderNextClass);

        if(next) {
            for(let el of next) {
                el.addEventListener('click', e => {
                    this.slider.next();
                });
            }
        }
    }

    //init slider dots
    initDots() {
        const btnsConts = document.querySelectorAll(this.dotsClass);
        if(!btnsConts || !this.slider) return;
        
        const unselectDots = () => {
            const activated = document.querySelectorAll(`${this.dotsClass} .active`);
            if(activated) {
                for (let el of activated) {
                    el.classList.remove('active');
                }
            }
        }

        //if not single controls
        for(let btns of btnsConts) {
            const btnList = btns.querySelectorAll(`${this.dotsClass} button`);

            btnList.forEach((btn, i) => {
                btn.addEventListener('click', (e) => {
                    this.slider.select(i);
                })
            });
    
            //activate custom dots on select slider event
            this.slider.on('select', (j) => {
                unselectDots();

                for(let btns of btnsConts) {
                    const btn = btns.children.item(j);

                    if (btn) {
                        btn.classList.add('active');
                    }
                }
            });
        }

    }

    //returns slider instance
    getSlider() {
        return this.slider;
    }
}